import {
    editYyjkDetail,
    MtDetail,
    MtNoMedicineDetail,
    getMtCelerityItemType,
    getRetailShopCats,
    fyyCategoryProps,
    fyyCategoryAttrValueList,
} from '@/api/prod/center/index';
import store from '@/store'

// 格式化每个商品数据
// isRequest 格式化发送请求数据 --- 默认是格式化响应请求的数据
export function _formatGoodsItem(r, isRequest) {
    if (!r) {
        console.warn('传入的参数 r 无效');
        return isRequest ? {} : {};
    }
     // 进一步检查 r.skuList 是否为有效值
     if (r.skuList !== null && r.skuList !== undefined && r.skuList.length > 0) {
        r.skuList = r.skuList.map(item => {
            delete item._skuid
            return isRequest ? {
                ...item,
                imageUrl: item.skuSpecifications? item.skuSpecifications[0].imageUrl:'',
                marketPrice: item.marketPrice || 0,
                // skuSpecifications: JSON.stringify(item.skuSpecifications ? item.skuSpecifications : [])
            } : {
                ...item,
                // skuSpecifications: item.skuSpecifications ? JSON.parse(item.skuSpecifications) : []
            }
        })
    }

    return isRequest ? {
        ...r,
        medicineType: 1,
        picture: JSON.stringify(r.picture ? r.picture : []),
        categoryLeafId: r.categoryIds? r.categoryIds[r.categoryIds.length - 1]:'',
        parentCategoryId: r.categoryIds? r.categoryIds[r.categoryIds.length - 2]:'',
        categoryIds: r.categoryIds ? r.categoryIds.join(',') : '',
        specifications: JSON.stringify(r.specifications ? r.specifications : []),
        skuInfo: JSON.stringify(r.skuInfo ? r.skuInfo : []),
    } : {
        ...r,
        medicineType: 1,
        picture: r.picture ? r.picture.split(','):[],
        attrs: r.attrs ? r.attrs : [],
        categoryIds: r.categoryIds ? r.categoryIds.split(',') : [],
        // headImgs: r.headImgs ? JSON.parse(r.headImgs) : [],
        // descInfo: r.descInfo ? JSON.parse(r.descInfo) : [],
        specifications: r.specifications ? JSON.parse(r.specifications) : [],
        skuInfo: r.skuInfo ? JSON.parse(r.skuInfo) : [],
        templateConfig: r.templateConfig ? JSON.parse(r.templateConfig) : [],
        productType: 1, // 目前只支持实物商品
    }
}


// 格式化每个商品数据
// isRequest 格式化发送请求数据 --- 默认是格式化响应请求的数据
export function _formatGoodsIteNoMedicine(r, isRequest) { 
    // 先检查 r 是否为有效值
    if (!r) {
        console.warn('传入的参数 r 无效');
        return isRequest ? {} : {};
    }

    if (!r.skuList || r.skuList.length === 0) {
        // 当 r.skuList 不存在或者为空时，可以选择直接返回 r 或者进行其他处理
        // 这里暂时不做额外处理
    } else { 
        r.skuList = r.skuList.map(item => { 
            delete item._skuid 
            return isRequest ? { 
                ...item, 
                // imageUrl: item.skuSpecifications? item.skuSpecifications[0].imageUrl:'', 
                // marketPrice: item.marketPrice || 0, 
                skuSpecifications: JSON.stringify(item.skuSpecifications ? item.skuSpecifications : []) 
            } : { 
                ...item, 
                skuSpecifications: item.skuSpecifications ? JSON.parse(item.skuSpecifications) : [] 
            } 
        }) 
    } 

    return isRequest ? { 
        ...r, 
        medicineType: 1, 
        picture: JSON.stringify(r.picture ? r.picture : []), 
        // quaPictures: JSON.stringify(r.quaPictures ? r.quaPictures : []), 
        categoryLeafId: r.categoryIds? r.categoryIds[r.categoryIds.length - 1]:'', 
        parentCategoryId: r.categoryIds? r.categoryIds[r.categoryIds.length - 2]:'', 
        categoryIds: r.categoryIds ? r.categoryIds.join(',') : '', 
        isSpecialty: r.isSpecialty ? 1: 0, 
        specifications: JSON.stringify(r.specifications ? r.specifications : []), 
        skuInfo: JSON.stringify(r.skuInfo ? r.skuInfo : []), 
        pictureContents: JSON.stringify(Array.isArray(r.pictureContents) ? r.pictureContents : []), 
        properties: JSON.stringify(r.properties ? r.properties : []), 
        commonAttrValue: JSON.stringify(r.commonAttrValue ? r.commonAttrValue : []), 
    } : { 
        ...r, 
        medicineType: 1, 
        picture: r.picture ? JSON.parse(r.picture) : [], 
        properties: r.properties ? JSON.parse(r.properties) : [], 
        // quaPictures: r.quaPictures ? JSON.parse(r.quaPictures) : [], 
        attrs: r.attrs ? r.attrs : [], 
        categoryIds: r.categoryIds ? r.categoryIds.split(',') : [], 
        specifications: r.specifications ? JSON.parse(r.specifications) : [], 
        skuInfo: r.skuInfo ? JSON.parse(r.skuInfo) : [], 
        isSpecialty: r.isSpecialty ? true: false, 
        pictureContents: JsonParseToArray(r.pictureContents),  
        commonAttrValue: r.commonAttrValue ? JSON.parse(r.commonAttrValue) : [], 
        templateConfig: r.templateConfig ? JSON.parse(r.templateConfig) : [], 
        productType: 1, // 目前只支持实物商品 
    } 
 }
 function JsonParseToArray(string){
    try{
        return JSON.parse(string).filter(item => !item.includes('blob:')) // 过滤掉 blob: 处理历史脏数据
    } catch(err){
        return []
    }
 }
/*
 * 获取 医药类型 1，医药，2非医药
 * 
 * @export
 * @param {any} params 
 * @returns 
* */
export function getMedicineType(params) {
    const {api_name,baseItemId,mtRapidType} = params
    return getMtCelerityItemType({api_name,baseItemId}).then(res => {
        if (res.result === 1) {
            return res.data;
        }
        return false;
    })
}

// 获取详情资料
export function getMtDetail(params) {
   
    if(params.mtRapidType == 2){
        delete params.mtRapidType
        return MtNoMedicineDetail(params).then(res => {
            if (res.result === 1) {
                return _formatGoodsIteNoMedicine(res.data)
            } else {
                return false
            }
        })
    } else {
        delete params.mtRapidType
        return MtDetail(params).then(res => {
            if (res.result === 1) {
                return _formatGoodsItem(res.data)
            } else {
                return false
            }
        })
    }
}

export function editYyjkInfo(params) {
    const mtRapidType = localStorage.getItem('mtRapidType')
    const _params = mtRapidType == 2 ?_formatGoodsIteNoMedicine(params, true): _formatGoodsItem(params, true)
  return editYyjkDetail(_params).then(res => {
      if (res.result === 1) {
      return true;
      }
      return false;
  })
}

export function getShopCategoryList(params) {
    return getRetailShopCats(params).then(res => {
        if (res.result === 1) {
        return res.data;
        }
        return false;
    })
  }

// 查询类目属性
export function getCategoryProps(data) {
    let _shopId = store.getters.shops_getCategoryPropShopId('yyjk')
    let _data = {
      ...data,
      shopId: data.shopId ? data.shopId : _shopId, // 默认店铺
      leafCategoryId: data.categoryId,
    }
    delete _data.categoryId
    return fyyCategoryProps(_data).then(res => {
      if (res.result === 1) {
        return res.data;
      } else {
        return false
      }
    })
  }

  export function getCategoryAttrValueList(data){
    return fyyCategoryAttrValueList(data).then(res => {
        if (res.result === 1) {
            return res.data;
        } else {
            return false
        }
    })
  }